import React from "react";
import { Box } from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core";

const rewriteTheme = (outerTheme) => {
  const { overrides } = outerTheme;
  const { MuiButton = {}, MuiBadge = {} } = overrides;
  MuiButton.root = { ...MuiButton.root, margin: "4px" };
  MuiBadge.badge = { border: "1px solid #FFF" };
  MuiBadge.anchorOriginTopRightRectangle = { top: 4, right: 4 };
  outerTheme.overrides.MuiButton = MuiButton;
  outerTheme.overrides.MuiBadge = MuiBadge;
  return outerTheme;
};
export default (props) => {
  const { children, ...restProps } = props;
  return (
    <MuiThemeProvider
      theme={(outerTheme) => {
        const innerTheme = rewriteTheme(outerTheme);
        return { ...innerTheme };
      }}
    >
      <Box mt={1} textAlign="right" {...restProps} mx={-0.5}>
        {children}
      </Box>
    </MuiThemeProvider>
  );
};
